import { CUSTOMER_JOURNEY_HOTEL_ERROR } from './../const';

function action() {
  return { type: CUSTOMER_JOURNEY_HOTEL_ERROR };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyHotelError.js